import {Directive, HostListener} from '@angular/core';
import {ImageLightboxService} from "../../services/image-lightbox/image-lightbox.service";

@Directive({
  selector: '[sb-image-lightbox]'
})
export class ImageLightboxDirective {

  constructor(private lightboxService: ImageLightboxService) { }

  @HostListener("click", ["$event"])
  public onClick($event: any): void {
    this.lightboxService.onClick($event);
  }
}
